import * as Yup from 'yup'
import {BaseEntity} from '../../../../shared/models/ApiModels'

export const HR_MAIL_TEMPLATE_PATH = '/hr/mail-template'

/** mail_template tablosu */
export interface IMailTemplateModel extends BaseEntity {
  name: string
  subject: string
  /** Zengin metin (HTML) */
  body: string
  description?: string | null
  active: boolean
}

/** Şablonda {{anahtar}} olarak kullanılabilen parametreler (backend enum'undan gelir) */
export interface IMailTemplateParam {
  key: string
  token: string
  label: string
  example: string
}

export interface IMailTemplateFormValues {
  name: string
  subject: string
  body: string
  description: string
  active: boolean
}

export const validationMailTemplate = Yup.object().shape({
  name: Yup.string().trim().required('Şablon adı zorunludur').max(150, 'En fazla 150 karakter olabilir'),
  subject: Yup.string().trim().required('Mail konusu zorunludur').max(255, 'En fazla 255 karakter olabilir'),
  body: Yup.string()
    .required('Mail içeriği zorunludur')
    .test('not-empty-html', 'Mail içeriği zorunludur', (value) => isFilledHtml(value)),
  description: Yup.string().trim().max(255, 'En fazla 255 karakter olabilir'),
})

export const initialMailTemplateForm: IMailTemplateFormValues = {
  name: '',
  subject: '',
  body: '',
  description: '',
  active: true,
}

export const toMailTemplateFormValues = (template: IMailTemplateModel): IMailTemplateFormValues => ({
  name: template.name,
  subject: template.subject,
  body: template.body,
  description: template.description ?? '',
  active: template.active !== false,
})

export const toMailTemplateModel = (values: IMailTemplateFormValues): IMailTemplateModel => ({
  name: values.name.trim(),
  subject: values.subject.trim(),
  body: values.body,
  description: values.description.trim(),
  active: values.active,
})

/** Quill boş bırakıldığında "<p><br></p>" döndürür; bunu dolu saymıyoruz */
export function isFilledHtml(html?: string | null) {
  if (!html) return false
  return htmlToText(html).length > 0
}

export function htmlToText(html: string) {
  return html
    .replace(/<br\s*\/?>/gi, ' ')
    .replace(/<[^>]*>/g, '')
    .replace(/&nbsp;/gi, ' ')
    .trim()
}

/** Şablon metnindeki parametreleri örnek değerleriyle doldurur (önizleme) */
export function fillWithExamples(text: string, params: IMailTemplateParam[]) {
  return params.reduce(
    (filled, param) => filled.replace(new RegExp(`\\{\\{\\s*${param.key}\\s*\\}\\}`, 'g'), param.example),
    text || ''
  )
}

/** Sunucuda tanımlı olmayan parametreler gönderim sırasında boş kalır; kullanıcıyı uyarırız */
export function findUnknownParams(text: string, params: IMailTemplateParam[]) {
  const known = new Set(params.map((param) => param.key))
  const found = new Set<string>()
  const pattern = /\{\{\s*([a-zA-Z0-9_]+)\s*\}\}/g
  let match = pattern.exec(text || '')
  while (match) {
    if (!known.has(match[1])) found.add(match[1])
    match = pattern.exec(text || '')
  }
  return Array.from(found)
}
